import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@shared/components/PageHeader";
import { ArrowLeft } from "lucide-react";
import { TemplateCard, TemplateCardProps } from "../../shared/components/templateCard";
import { useDefaultTemplate } from "../hooks";

// Helper function to map category to badge label
const getCategoryBadge = (category: string) => {
  const categoryMap: Record<string, string> = {
    MARKETING_ENGAGEMENT: "Marketing",
    OUTAGE_EMERGENCY: "Emergency",
    FIELD_OPERATIONS: "Operations",
    CUSTOMER_SERVICE: "Service",
    BILLING: "Billing",
    NOTIFICATION: "Notification",
    ONBOARDING: "Onboarding",
  };
  return categoryMap[category] || "General";
};

const ChooseTemplates = () => {
  const navigate = useNavigate();
  const { data: defaultTemplateData } = useDefaultTemplate();
  console.log("defaultTemplateData", defaultTemplateData);

  // Static templates (AI and Custom)
  const staticTemplates: TemplateCardProps[] = [
    {
      id: 1,
      icon: "ai",
      title: "AI Generated",
      description: "Describe your email and let AI create it for you",
    },
    {
      id: 2,
      icon: "custom",
      title: "Custom Template",
      description: "Start with a blank template",
    },
  ];

  // Transform API data to template format
  const apiTemplates: TemplateCardProps[] = defaultTemplateData?.results
    ? defaultTemplateData.results.map((item: any) => ({
        id: item.id,
        icon: "template" as const,
        title: item.templateName,
        description: item.description,
        badges: [
          {
            label: getCategoryBadge(item.templateCategory),
            variant: "primary" as const,
          },
          // Add channel badge
          {
            label: item.channelName,
            variant: "secondary" as const,
          },
        ],
      }))
    : [];

  // Combine static and API templates
  const templates = [...staticTemplates, ...apiTemplates];

  const handleTemplateClick = (template: TemplateCardProps) => {
    if (template.icon === "custom") {
      // Custom template goes to add route
      navigate("/communication-hub/templates/add");
    } else {
      // AI and preset templates go to edit route with id and name
      navigate(
        `/communication-hub/templates/edit/${template.id}/${encodeURIComponent(
          template.title
        )}`
      );
    }
  };

  return (
    <div className="space-y-6 p-6">
      {/* Header Section */}
      <div className="flex items-center gap-4">
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700 hover:text-gray-900"
          onClick={() => navigate("/communication-hub/templates")}
        />
        <div className="flex flex-col">
          <PageHeader
            title="Choose Your Template"
            subtitle="Select from water utility-specific templates or create with AI"
          />
        </div>
      </div>

      {/* Templates Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {templates.map((template) => (
          <TemplateCard
            key={template.id}
            {...template}
            onClick={() => handleTemplateClick(template)}
          />
        ))}
      </div>
    </div>
  );
};

export default ChooseTemplates;